// internal
import { BrandType } from '@app/store/typings/actions/brand.d';
import { BrandState } from '@app/store/typings/state/brand.d';

const initState: BrandState = {
  id: '',
  currentBrand: {
    _id: '',
    status: '',
    name: '',
    logo: '',
    picture: '',
    addresses: [],
    contact: {
      phone: '',
      email: '',
      fax: '',
      link: '',
    },
    roles: [],
    users: [],
    businessType: '',
    branchCode: '',
    vatStatus: undefined,
    taxId: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
  },
  brandCreateBy: {
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  },
  data: [],
  meta: {
    limit: 0,
    offset: 0,
    total: 0,
  },
  createBrand: {
    message: '',
    isSuccess: false,
  },
  listRole: {
    data: [],
    meta: {
      limit: 0,
      offset: 0,
      total: 0,
    },
    currentRole: {
      _id: '',
      statements: [],
      brandId: '',
      name: '',
      createdAt: '',
      updatedAt: '',
    },
  },
};

export const brand = (state = initState, action: BrandType) => {
  switch (action.type) {
    case 'KEY_BRAND_SELECT_ID':
      return { ...state, id: action.payload };
    case 'KEY_BRAND_SET_DATA':
      return { ...state, data: action.payload.data, meta: action.payload.meta };
    case 'KEY_BRAND_CREATE_SUCCESS':
      state.createBrand.isSuccess = true;
      return { ...state };
    case 'KEY_BRAND_SET_LISTROLES':
      state.listRole.data = action.payload.data;
      state.listRole.meta = action.payload.meta;
      return { ...state };
    case 'KEY_BRAND_SET_WITHID':
      state.currentBrand = action.payload;
      return { ...state };
    case 'KEY_BRAND_CLEAR_CURRENTNAME':
      state.currentBrand.name = '';
      return { ...state };
    case 'KEY_BRAND_SET_CURRENTROLE':
      state.listRole.currentRole = action.payload;
      return { ...state };
    case 'KEY_BRAND_CLEAR_CURRENTROLE':
      state.listRole.currentRole = undefined;
      return { ...state };
    case 'KEY_BRAND_CREATEBY_SETDATA':
      state.brandCreateBy.title = action.payload.title || '-';
      state.brandCreateBy.firstName = action.payload.firstName || '-';
      state.brandCreateBy.lastName = action.payload.lastName || '-';
      state.brandCreateBy.email = action.payload.email || '-';
      state.brandCreateBy.phone = action.payload.phone || '-';
      return { ...state };
    case 'KEY_BRAND_CREATEBY_CLEAR':
      state.brandCreateBy.title = '-';
      state.brandCreateBy.firstName = '-';
      state.brandCreateBy.lastName = '-';
      state.brandCreateBy.email = '-';
      state.brandCreateBy.phone = '-';
      return { ...state };
    default:
      return state;
  }
};
